import { render, staticRenderFns } from "./Standard.vue?vue&type=template&id=7f97746d"
import script from "./Standard.vue?vue&type=script&lang=ts"
export * from "./Standard.vue?vue&type=script&lang=ts"
import style0 from "./Standard.vue?vue&type=style&index=0&id=7f97746d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports